import { useState, type InputHTMLAttributes } from 'react';
import { cx } from './cx.js';

/**
 * Text input. `reveal` turns a password field into one you can check before
 * saving — every secret on the APIs pane is entered blind today, into a field
 * whose only label is its placeholder.
 */
export function TextInput({
  mono = false,
  reveal = false,
  className,
  ...rest
}: { mono?: boolean; reveal?: boolean } & InputHTMLAttributes<HTMLInputElement>) {
  const [shown, setShown] = useState(false);
  const type = reveal && shown ? 'text' : rest.type;

  const input = (
    <input {...rest} type={type} className={cx('ui-input', mono && 'ui-input--mono', className)} />
  );
  if (!reveal) return input;

  return (
    <span className="ui-input-wrap">
      {input}
      <button
        type="button"
        className="ui-input__reveal"
        onClick={() => setShown((v) => !v)}
        aria-label={shown ? 'Hide' : 'Show'}
        title={shown ? 'Hide' : 'Show'}
      >
        {shown ? 'Hide' : 'Show'}
      </button>
    </span>
  );
}
